const recordResult = (currentValue, lastValidationResult) => {
  if (lastValidationResult) {
    return currentValue;
  } else {
    return lastValidationResult;
  }
};

const validateRequiredParameter = (bundle, candidate, name, defaultValue) => {
  if (candidate) {
    bundle[name] = candidate;
    return true;
  } else if (defaultValue) {
    bundle[name] = defaultValue;
    return true;
  }
  bundle.errors.push(name);
  return false;
};

const validateOptionalParameter = (bundle, candidate, name, defaultValue) => {
  const result = candidate !== undefined ? candidate : defaultValue;
  bundle[name] = result;
};

const fieldsForValidationByPage = {
  registration: [
    {
      isRequired: true,
      name: 'language',
      defaultValue: 'en-GB',
    },
    {
      isRequired: true,
      name: 'profileType',
    },
    {
      isRequired: true,
      name: 'apiUrl',
    },
    {
      isRequired: false,
      name: 'securityApiKey',
      defaultValue: '',
    },
    {
      isRequired: false,
      name: 'securityApiUrl',
      defaultValue: '',
    },
    {
      isRequired: false,
      name: 'staticApiKey',
      defaultValue: '',
    },
    {
      isRequired: false,
      name: 'staticApiUrl',
      defaultValue: '',
    },
    {
      isRequired: false,
      name: 'showBackButton',
      defaultValue: true,
    },
    {
      isRequired: false,
      name: 'showAlreadyHaveAccountMessage',
      defaultValue: true,
    },
    {
      isRequired: false,
      name: 'leadSource',
      defaultValue: undefined,
    },
    {
      isRequired: false,
      name: 'bypassApigee',
      defaultValue: false,
    },
  ],
  SignIn: [
    {
      isRequired: true,
      name: 'language',
      defaultValue: 'en-GB',
    },
    {
      isRequired: false,
      name: 'isQuickCancel',
      defaultValue: false,
    },
    {
      isRequired: false,
      name: 'staticApiKey',
      defaultValue: '',
    },
    {
      isRequired: false,
      name: 'staticApiUrl',
      defaultValue: '',
    },
  ],
  'my-subscription': [
    {
      isRequired: true,
      name: 'urlParams',
      defaultValue: '{type=a}',
    },
    {
      isRequired: true,
      name: 'language',
      defaultValue: 'en-GB',
    },
    {
      isRequired: true,
      name: 'profileType',
    },
    {
      isRequired: true,
      name: 'apiUrl',
    },
    {
      isRequired: false,
      name: 'staticApiKey',
      defaultValue: '',
    },
    {
      isRequired: false,
      name: 'staticApiUrl',
      defaultValue: '',
    },
    {
      isRequired: false,
      name: 'showBackButton',
      defaultValue: true,
    },
    {
      isRequired: false,
      name: 'showAlreadyHaveAccountMessage',
      defaultValue: true,
    },
    {
      isRequired: false,
      name: 'leadSource',
      defaultValue: undefined,
    },
    {
      isRequired: false,
      name: 'productExternalReference',
    },
    {
      isRequired: false,
      name: 'productExternalReferenceType',
    },
    {
      isRequired: false,
      name: 'pricingPlanExternalReference',
    },
    {
      isRequired: false,
      name: 'pricingPlanExternalReferenceType',
    },
    {
      isRequired: false,
      name: 'cdStripeHeader',
      defaultValue: 0,
    },
    {
      isRequired: false,
      name: 'isQuickCancel',
      defaultValue: false,
    },
    {
      isRequired: false,
      name: 'bypassApigee',
      defaultValue: false,
    },
  ],
  'my-account': [
    {
      isRequired: false,
      name: 'language',
      defaultValue: 'en-GB',
    },
    {
      isRequired: false,
      name: 'isQuickCancel',
      defaultValue: false,
    },
  ],
  payment: [
    {
      isRequired: true,
      name: 'language',
      defaultValue: 'en-GB',
    },
    {
      isRequired: false,
      name: 'staticApiKey',
      defaultValue: '',
    },
    {
      isRequired: false,
      name: 'staticApiUrl',
      defaultValue: '',
    },
    {
      isRequired: false,
      name: 'productExternalReference',
    },
    {
      isRequired: false,
      name: 'productExternalReferenceType',
    },
    {
      isRequired: false,
      name: 'pricingPlanExternalReference',
    },
    {
      isRequired: false,
      name: 'pricingPlanExternalReferenceType',
    },
    {
      isRequired: false,
      name: 'cdStripeHeader',
      defaultValue: 0,
    },
    {
      isRequired: false,
      name: 'bypassApigee',
      defaultValue: false,
    },
  ],
  OrderHistory: [
    {
      isRequired: true,
      name: 'language',
      defaultValue: 'en-GB',
    },
    {
      isRequired: false,
      name: 'productExternalReference',
    },
    {
      isRequired: false,
      name: 'productExternalReferenceType',
    },
    {
      isRequired: false,
      name: 'pricingPlanExternalReference',
    },
    {
      isRequired: false,
      name: 'pricingPlanExternalReferenceType',
    },
  ],
};

const validateMessage = (message) => {
  const bundle = {
    isValid: true,
    errors: [],
  };
  const params = message?.params || [];
  const page = message?.page || '/';
  const fieldsForValidation = fieldsForValidationByPage[page] || [
    {
      isRequired: true,
      name: 'language',
      defaultValue: 'en-GB',
    },
  ];

  if (fieldsForValidation.length > 0) {
    fieldsForValidation.forEach((fieldForValidation) => {
      if (fieldForValidation.isRequired) {
        bundle.isValid = recordResult(
          bundle.isValid,
          validateRequiredParameter(
            bundle,
            params[fieldForValidation.name],
            fieldForValidation.name,
            fieldForValidation.defaultValue,
          ),
        );
      } else {
        validateOptionalParameter(
          bundle,
          params[fieldForValidation.name],
          fieldForValidation.name,
          fieldForValidation.defaultValue,
        );
      }
    });
  }
  return bundle;
};

export default validateMessage;
